
/* tslint:disable */
const templateData = `
<a ng-if="!prefixKey" href="ugc/{{user.id}}">{{user | userDisplayName}}</a><span ng-if="prefixKey" ng-bind-html="::prefixKey | translate: {userLink: linkHtml}"></span>

`;
export = templateData;
